import React, { useState, useContext, useRef } from 'react';
import Telephone from '../../../UI/Telephone';
import { numberValidation } from '../../../../Utility/Validations';
import { usePhoneValidation } from '../../../../Hooks/usePhoneValidation';
import VisitorParamsContext from '../../../../Contexts/VisitorParams';
import Email from '../../../UI/Email';
import { useEmailValidation } from '../../../../Hooks/useEmailValidation';
import { slideValidation } from '../../../../Utility/Validations';
import GTMDataLayer from '../../../../Utility/GTMDataLayer';

const ContactDetails = (props) => {
	const { phoneValidation } = usePhoneValidation();
	const { emailValidation } = useEmailValidation();
	const { visitorParameters } = useContext(VisitorParamsContext);
	const uuid = visitorParameters.visitor_parameters.uuid;
	const [contactValidation, setContactValidation] = useState({
		txtPhone: false,
		txtEmail: false,
	});
	const [submitting, setSubmitting] = useState(false);
	const eventOnchange = (e) => {
		var field = e.target.id;
		setContactValidation((prevState) => ({
			...prevState,
			[field]: false,
		}));
		if (e.target.name == 'txtPhone') {
			phoneValidCheck();
		}
	};

	const phoneValidCheck = async () => {
		const isValid = await props.trigger("txtPhone");
		if (!isValid) return;
		const values = props.getValues();
		const phone = values['txtPhone'].replace(/^0+/, '');
		if (phone !== '') {
			if (phone.length > 11) {
				setContactValidation((prevState) => ({
					...prevState,
					txtPhone: false,
				}));
				props.setError('txtPhone', {
					type: 'manual',
					message: 'Please Enter Valid Mobile Number',
				});
				setSubmitting(false);
				return 0;
			}
			const getPhoneValidation = await phoneValidation(phone, uuid);
			if (getPhoneValidation.data.status_code === 0) {
				setContactValidation((prevState) => ({
					...prevState,
					txtPhone: false,
				}));
				props.setError('txtPhone', {
					type: 'manual',
					message: 'Please Enter Valid Mobile Number',
				});
				setSubmitting(false);
				return 0;
			} else if (getPhoneValidation.data.status_code === 2) {
				setContactValidation((prevState) => ({
					...prevState,
					txtPhone: false,
				}));
				props.setError('txtPhone', {
					type: 'manual',
					message: 'Mobile Number Already Exist',
				});
				setSubmitting(false);
				return 0;
			} else if (getPhoneValidation.data.status_code === 3) {
				setContactValidation((prevState) => ({
					...prevState,
					txtPhone: false,
				}));
				props.setError('txtPhone', {
					type: 'manual',
					message: 'Please Enter Valid Mobile Number',
				});
				setSubmitting(false);
				return 0;
			} else {
				setContactValidation((prevState) => ({
					...prevState,
					txtPhone: true,
				}));
				props.clearErrors('txtPhone');
				return 1;
			}
		} else {
			props.setError('txtPhone', {
				type: 'manual',
				message: 'Please Enter Valid Mobile Number',
			});
			setSubmitting(false);
			return 0;
		}
	};

	const emailValidCheck = async () => {
		const values = props.getValues();
		const email = values['txtEmail'];
		if (email !== '') {
			const getEmailValidation = await emailValidation(email, uuid);
			if (getEmailValidation.data.status_code === 1) {
				setContactValidation((prevState) => ({
					...prevState,
					txtEmail: true,
				}));
				props.clearErrors('txtEmail');
				return 1;
			} else {
				setContactValidation((prevState) => ({
					...prevState,
					txtEmail: false,
				}));
				props.setError('txtEmail', {
					type: 'manual',
					message: 'Invalid Email',
				});
				setSubmitting(false);
			}
		} else {
			props.setError('txtEmail', {
				type: 'manual',
				message: 'Please Enter Valid Email',
			});
			setSubmitting(false);
		}
	};

	const handleContactDetails = async (e) => {
		e.preventDefault();
		const values = props.getValues();
		try {
			var validationArr = ['txtPhone', 'txtEmail'];
			const validationCheck = await slideValidation(
				validationArr,
				props.trigger
			);
			if (validationCheck === 'Success') {
				setSubmitting(true);
				const phoneValid = await phoneValidCheck();
				const emailValid = await emailValidCheck();
				if (!values['txtPhone']) {
					props.setError('txtPhone', {
						type: 'manual',
						message: 'Please Enter Valid Mobile Number',
					});
					setSubmitting(false);
					return;
				}
				const contactStatus = Object.entries(contactValidation).find(
					([key, value]) => value === false
				);
				if (contactStatus) {
					if (phoneValid == 1 && emailValid == 1) {
						await props.formSubmit();
						GTMDataLayer({
							clickEvent: 'slideclick',
							question: 'contact details',
							answer: '',
						});
						props.slideChange(e);
					}
				} else if (
					contactStatus === undefined &&
					(phoneValid != 1 || emailValid != 1)
				) {
					await phoneValidCheck();
					await emailValidCheck();
				} else {
					GTMDataLayer({
						clickEvent: 'slideclick',
						question: 'contact details',
						answer: '',
					});
					await props.formSubmit();
					//props.slideChange(e);
				}
			}
		} catch (error) {
			console.error('Error during validation or submission process:', error);
		}
	};

	return (
		<div className={props.slideStatus}>
			<label class="mt-3 mb-3"  style={{fontSize:"18px",textAlign:"center"}} htmlFor="Date of Birt">What’s the Best Way to Contact You About this Benefit?</label>			<Telephone
				id="txtPhone"
				className="form-control w-100 field-secure cont-icon privacy-label "
				placeholder="Mobile Number"
				onKeyPress={(e) => {
					numberValidation(e);
				}}
				maxLength="11"
				minLength="11"
				autoComplete="off"
				register={props.register('txtPhone', {
					required: 'Please Enter Mobile Number',
					pattern: {
						// value: /^[0-9]*$/i,
						value: /^(07|7)\d{9,10}$/,
						message: 'Please Enter Valid Mobile Number',
					},
					// validate: (value) =>
					// 	value.length === 11 || 'Mobile Number must be exactly 11 digits',
					onChange: (e) => {
						if (e.target.value.length >= 11) {
							props.clearErrors('txtPhone');
							eventOnchange(e);
						}
					},
					disabled: submitting,
					onBlur: phoneValidCheck,
				})}
				validationMsg={
					props.validationMsg.txtPhone &&
					props.validationMsg.txtPhone.message
				}
			></Telephone>
			<Email
				className="date-of-b privacy-label"
				id="txtEmail"
				placeholder="Email Address"
				autoComplete="off"
				onKeyDown={(e) => {
					if (e.key === ' ') e.preventDefault();
					// props.clearErrors('txtEmail');
					// eventOnchange(e);
				}}
				register={props.register('txtEmail', {
					required: 'Please Enter Valid Email Address',
					pattern: {
						value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
						message: 'Please Enter Valid Email Address',
					},
					disabled: props.emailcheck,
					onBlur: emailValidCheck,
				})}
				validationMsg={
					props.validationMsg.txtEmail &&
					props.validationMsg.txtEmail.message
				}
			></Email>
			<button
				type="button"
				name="next5"
				onClick={handleContactDetails}
				className="next-btn"
				disabled={submitting}
			>
				Check Eligibility
			</button>
		</div>
	);
};

export default ContactDetails;